<div class="custom-header-container shadow-2 flex justify-content-between align-items-center px-4">
  <div class="flex align-items-center gap-2">
    <button pButton pRipple icon="pi pi-bars" id="button-toggle" class="p-button-rounded p-button-text"
      (click)="toggleSidenav()"></button>

    <ng-container *ngIf="vm$ | async as vm">
      <img *ngIf="vm.logoUrl" [src]="vm.logoUrl" class="header-logo-img" alt="Logo institución" />
      <div class="header-title ml-2">
        <p>{{ vm.entidad?.tituloPrincipal || 'Sistema G.D.I.' }}</p>

        <p *ngIf="vm.entidad?.nombre">{{ vm.entidad?.nombre }}</p>

        <p *ngIf="!vm.entidad?.nombre">GOVTECH</p>
      </div>
    </ng-container>
  </div>

  <div class="flex align-items-center gap-4">
    <div class="header-user hidden md:flex">
      <p>{{ userDisplayName }}</p>
      <p>{{ userDisplayRole }}</p>
    </div>

    <app-notification-bell></app-notification-bell>

    <button pButton icon="pi pi-power-off" class="p-button-rounded p-button-text text-white hover:bg-white-alpha-10"
      pTooltip="Cerrar Sesión" tooltipPosition="bottom" (click)="logout()"></button>
  </div>
</div>

<p-confirmDialog key="headerLogoutDialog" #headerLogoutCd [closable]="true" [closeOnEscape]="true" appendTo="body"
  position="center" [baseZIndex]="12000" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [style]="{ width: '35rem' }" header="Cierre de sesión">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-text"
      (click)="headerLogoutCd.reject()"></button>
    <button type="button" pButton label="Cerrar Sesión" class="button-danger" (click)="headerLogoutCd.accept()">
      <lucide-icon name="log-out" class="button-icon mr-2"></lucide-icon>
    </button>
  </ng-template>
</p-confirmDialog>